<template>
  <div id="main_div">
    <section class="details-product">
      <div class="container">
        <div v-if="isLoading" class="skeleton-loader-container mt-4">
          <div class="card shadow p-4 mb-5 bg-white rounded">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="skeleton-pulse skeleton-btn"></div>
              <div class="skeleton-pulse skeleton-title mx-auto"></div>
            </div>
            <hr />
            <div class="skeleton-pulse skeleton-section-title mb-3"></div>
            <div class="d-flex flex-wrap">
              <div class="data-item" v-for="i in 6" :key="i">
                <div class="skeleton-pulse skeleton-label mb-2"></div>
                <div class="skeleton-pulse skeleton-value"></div>
              </div>
            </div>
            <hr />
            <div class="skeleton-pulse skeleton-section-title mb-3"></div>
            <div class="d-flex flex-wrap">
              <div class="data-item" v-for="i in 9" :key="i">
                <div class="skeleton-pulse skeleton-label mb-2"></div>
                <div class="skeleton-pulse skeleton-value"></div>
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-around mb-4">
              <div class="skeleton-pulse skeleton-img"></div>
              <div class="skeleton-pulse skeleton-img"></div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-md mt-4">
            <div class="details-product__content">
              <b-card class="card shadow p-3 mb-5 bg-white rounded">
                <b-col cols="4">
                  <b-link class="text-left h4" @click="$router.go(-1)">
                    <b-icon
                      icon="chevron-left"
                      style="width: 25px; height: 25px"
                    ></b-icon>
                    Kembali
                  </b-link>
                </b-col>
                <h2 class="font-weight-bold text-center">
                  Detail Pengajuan Badan Hukum
                </h2>
                <hr />
                <h4>Data Pengajuan</h4>
                <div class="d-flex flex-wrap">
                  <div class="data-item">
                    <h5>Nama Produk</h5>
                    <span
                      v-if="safeGet(itemPengajuans, 'product.nama_produk')"
                      >{{
                        formatCapitalized(itemPengajuans.product.nama_produk)
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Nama Mitra</h5>
                    <span
                      v-if="
                        safeGet(
                          itemPengajuans,
                          'mitra.mitra_profile.nama_organisasi_perusahaan'
                        )
                      "
                      >{{
                        itemPengajuans.mitra.mitra_profile
                          .nama_organisasi_perusahaan
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kategori Produk</h5>
                    <span
                      v-if="safeGet(itemPengajuans, 'product.category.name')"
                      >{{
                        formatCapitalized(itemPengajuans.product.category.name)
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Sub Kategori Produk</h5>
                    <span
                      v-if="
                        safeGet(itemPengajuans, 'product.sub_category.name')
                      "
                      >{{
                        formatCapitalized(
                          itemPengajuans.product.sub_category.name
                        )
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Jumlah Setoran Awal</h5>
                    <span>{{ formatRupiah(itemPengajuans.setoran_awal) }}</span>
                  </div>
                  <div class="data-item"></div>
                </div>
                <hr />

                <h4>Data Badan Hukum</h4>
                <div class="d-flex flex-wrap">
                  <div class="data-item">
                    <h5>Nama Badan Hukum</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_detail.legal_entity_name'
                        )
                      "
                      >{{ items.user_corporate_detail.legal_entity_name }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Jenis Badan Hukum</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_detail.legal_entity_type.name'
                        )
                      "
                      >{{
                        items.user_corporate_detail.legal_entity_type.name
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Bidang Usaha</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_detail.business_field.name'
                        )
                      "
                      >{{
                        items.user_corporate_detail.business_field.name
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>NPWP Badan Hukum</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.taxpayer_number')" 
                      :value="items.user_corporate_detail.taxpayer_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.taxpayer_document_path')"
                      :href="items.user_corporate_detail.taxpayer_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>

                  <div class="data-item">
                    <h5>Akta Pendirian</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.deed_number')" 
                      :value="items.user_corporate_detail.deed_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.deed_document_path')"
                      :href="items.user_corporate_detail.deed_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>

                  <div class="data-item">
                    <h5>Akta Perubahan Terakhir</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.latest_deed_number')" 
                      :value="items.user_corporate_detail.latest_deed_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.latest_deed_document_path')"
                      :href="items.user_corporate_detail.latest_deed_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>

                  <div class="data-item">
                    <h5>SK Kemenkumham Pendirian</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.establishment_menkumham_number')" 
                      :value="items.user_corporate_detail.establishment_menkumham_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.establishment_menkumham_document_path')"
                      :href="items.user_corporate_detail.establishment_menkumham_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>

                  <div class="data-item">
                    <h5>SK Kemenkumham Perubahan Terakhir</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.latest_menkumham_number')" 
                      :value="items.user_corporate_detail.latest_menkumham_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.latest_menkumham_document_path')"
                      :href="items.user_corporate_detail.latest_menkumham_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>

                  <div class="data-item">
                    <h5>Nomor Induk Berusaha (NIB)</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.business_identification_number')" 
                      :value="items.user_corporate_detail.business_identification_number" />
                    <span v-else>-</span>
                    <a
                      v-if="safeGet(items,'user_corporate_detail.business_identification_document_path')"
                      :href="items.user_corporate_detail.business_identification_document_path"
                      target="_blank"
                      class="d-flex align-items-center mt-3"
                    >
                      <b-img :src="require('@/assets/images/icon/icon-pdf.png')" alt="PDF" style="max-width: 100px"/>
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>
                  <div class="data-item">
                    <h5>tanggal Didirikan</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.establishment_date')" 
                      :value="establishment_date_parsed" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>alamat Badan Hukum</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.address')" 
                      :value="items.user_corporate_detail.address" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Provinsi</h5>
                    <span v-if="safeGet(wilayah_corporate, 'provinsi')">{{
                      wilayah_corporate.provinsi
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kabupaten/Kota</h5>
                    <span v-if="safeGet(wilayah_corporate, 'kota')">{{
                      wilayah_corporate.kota
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kecamatan</h5>
                    <span v-if="safeGet(wilayah_corporate, 'kecamatan')">{{
                      wilayah_corporate.kecamatan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Desa/Kelurahan</h5>
                    <span v-if="safeGet(wilayah_corporate, 'kelurahan')">{{
                      wilayah_corporate.kelurahan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kode Pos</h5>
                    <span
                      v-if="safeGet(items, 'user_corporate_detail.postal_code')"
                      >{{ items.user_corporate_detail.postal_code }}</span
                    >
                    <span v-else>-</span>
                  </div>

                  <div class="data-item">
                    <h5>No. Ponsel Badan Hukum</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.phone')" 
                      :value="items.user_corporate_detail.phone" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Email Badan Hukum</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_detail.email')" 
                      :value="items.user_corporate_detail.email" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Tujuan Pembukaan Rekening</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_detail.account_opening_purpose.name'
                        )
                      "
                      >{{
                        items.user_corporate_detail.account_opening_purpose.name
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Sumber Dana</h5>
                    <span
                      v-if="
                        safeGet(items, 'user_corporate_detail.fund_source.name')
                      "
                      >{{ items.user_corporate_detail.fund_source.name }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Perkiraan Nilai Transaksi dalam 1 Tahun</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_detail.estimated_transaction_value.name'
                        )
                      "
                      >{{
                        items.user_corporate_detail.estimated_transaction_value
                          .name
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item"></div>
                </div>

                <hr />
                <h4>Data Diri PIC Badan Hukum</h4>
                <div class="d-flex flex-wrap">
                  <!-- <div class="data-item">
                                        <h5>Jabatan</h5>
                                        <span v-if="items.position != null">{{ items.position.name }}</span>
                                        <span v-else>-</span>
                                    </div> -->
                  <div class="data-item">
                    <h5>Nama Lengkap (sesuai KTP)</h5>
                    <span v-if="items.name != null">{{ items.name }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Jenis Kelamin</h5>
                    <span
                      v-if="safeGet(items, 'user_corporate_profile.gender')"
                      >{{
                        formatCapitalized(items.user_corporate_profile.gender)
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kewarganegaraan</h5>
                    <span
                      v-if="safeGet(items, 'user_corporate_profile.country')"
                      >{{
                        items.user_corporate_profile.country.toUpperCase()
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>No. Ponsel Yang Terhubung Ke WA</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'no_telpon')" 
                      :value="items.no_telpon" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>No. Ponsel/Telepon Alternatif</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.alternate_phone')" 
                      :value="items.user_corporate_profile.alternate_phone" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Tempat Lahir</h5>
                    <span
                      v-if="
                        safeGet(items, 'user_corporate_profile.place_of_birth')
                      "
                      >{{ items.user_corporate_profile.place_of_birth }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Tanggal Lahir</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.date_of_birth')" 
                      :value="date_of_birth_parsed" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Email</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'email')" 
                      :value="items.email" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Nomor Tanda Pengenal</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.identity_number') && safeGet(items,'user_corporate_profile.identity_type.name')" 
                      :value="items.user_corporate_profile.identity_type.name + ' - ' + items.user_corporate_profile.identity_number" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Tempat Diterbitkan</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_profile.identity_issued_place'
                        )
                      "
                      >{{
                        items.user_corporate_profile.identity_issued_place
                      }}</span
                    >
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Masa Berlaku Tanda Pengenal</h5>
                    <span
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_profile.identity_lifetime'
                        )
                      "
                      >{{
                        items.user_corporate_profile.identity_lifetime == true
                          ? "seumur Hidup"
                          : formatDateIndonesian(
                              items.user_corporate_profile.identity_expiry
                            )
                      }}</span
                    >
                  </div>
                  <div class="data-item">
                    <h5>NPWP</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.taxpayer_number')" 
                      :value="items.user_corporate_profile.taxpayer_number" />
                    <span v-else>-</span>
                    <a
                      v-if="
                        safeGet(
                          items,
                          'user_corporate_profile.taxpayer_document_path'
                        )
                      "
                      :href="
                        items.user_corporate_profile.taxpayer_document_path
                      "
                      target="_blank"
                      class="d-flex align-items-center"
                    >
                      <b-img
                        :src="require('@/assets/images/icon/icon-pdf.png')"
                        alt="PDF"
                        style="max-width: 100px"
                      />
                      <span class="ml-2">Klik untuk membuka file PDF</span>
                    </a>
                  </div>
                  <div class="data-item">
                    <h5>Alamat Sesuai KTP</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.identity_address')" 
                      :value="items.user_corporate_profile.identity_address" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Provinsi</h5>
                    <span v-if="safeGet(wilayah_profile, 'provinsi')">{{
                      wilayah_profile.provinsi
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kabupaten/Kota</h5>
                    <span v-if="safeGet(wilayah_profile, 'kota')">{{
                      wilayah_profile.kota
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kecamatan</h5>
                    <span v-if="safeGet(wilayah_profile, 'kecamatan')">{{
                      wilayah_profile.kecamatan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Desa/Kelurahan</h5>
                    <span v-if="safeGet(wilayah_profile, 'kelurahan')">{{
                      wilayah_profile.kelurahan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item"></div>
                  <div class="data-item">
                    <h5>alamat Domisili</h5>
                    <MaskingViewData 
                      v-if="safeGet(items,'user_corporate_profile.current_address')" 
                      :value="items.user_corporate_profile.current_address" />
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Provinsi</h5>
                    <span v-if="safeGet(wilayah_domicily, 'provinsi')">{{
                      wilayah_domicily.provinsi
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kabupaten/Kota</h5>
                    <span v-if="safeGet(wilayah_domicily, 'kota')">{{
                      wilayah_domicily.kota
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Kecamatan</h5>
                    <span v-if="safeGet(wilayah_domicily, 'kecamatan')">{{
                      wilayah_domicily.kecamatan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item">
                    <h5>Desa/Kelurahan</h5>
                    <span v-if="safeGet(wilayah_domicily, 'kelurahan')">{{
                      wilayah_domicily.kelurahan
                    }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="data-item"></div>
                </div>
                <hr />
                <h4>e-KYC PIC Badan Hukum</h4>
                <div class="d-flex flex-wrap">
                  <!-- Status Sertifikasi -->
                  <div class="data-item">
                    <h5>Status Sertifikasi</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        convertCertificationStatus(items.user_tilaka.cer_status)
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Status Registrasi -->
                  <div class="data-item">
                    <h5>Status Registrasi</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{ convertStatus(items.user_tilaka.reg_status) }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Verifikasi NIK -->
                  <div class="data-item">
                    <h5>Verifikasi NIK</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        items.user_tilaka.reg_nik
                          ? "✅ Valid"
                          : "❌ Tidak Valid"
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Verifikasi Nama -->
                  <div class="data-item">
                    <h5>Verifikasi Nama</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        items.user_tilaka.reg_nama
                          ? "✅ Valid"
                          : "❌ Tidak Valid"
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- FR Score -->
                  <div class="data-item">
                    <h5>FR Score</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{ items.user_tilaka.reg_fr_score }} ({{
                        items.user_tilaka.reg_fr_score_percentage
                      }}%) -
                      <strong>{{
                        convertFRScore(
                          items.user_tilaka.reg_fr_score,
                          items.user_tilaka.reg_fr_score_percentage
                        )
                      }}</strong>
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Hasil Liveness -->
                  <div class="data-item">
                    <h5>Hasil Liveness</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        items.user_tilaka.reg_liveness_result
                          ? "✅ Lolos"
                          : "❌ Gagal"
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Hasil Akhir Verifikasi -->
                  <div class="data-item">
                    <h5>Ringkasan Verifikasi</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        items.user_tilaka.reg_summary_verification_result
                          ? "✅ Berhasil"
                          : "❌ Gagal"
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Kode Alasan -->
                  <div class="data-item">
                    <h5>Status e-KYC</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{ convertReasonCode(items.user_tilaka.reg_reason_code) }}
                    </span>
                    <span v-else>-</span>
                  </div>

                  <!-- Status Registrasi Manual -->
                  <div class="data-item">
                    <h5>Status Registrasi Manual</h5>
                    <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                      {{
                        convertManualRegistration(
                          items.user_tilaka.reg_manual_registration_status
                        )
                      }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
                <hr />
                <div
                  class="d-flex justify-content-around align-items-center mb-3"
                >
                  <!-- Foto KTP Section -->
                  <div class="text-center flex-fill mx-2">
                    <h4 class="mb-2">Foto KTP</h4>
                    <img
                      v-if="
                        safeGet(items, 'user_corporate_profile.foto_ktp_path')
                      "
                      :src="items.user_corporate_profile.foto_ktp_path"
                      alt="Foto KTP"
                      class="img-fluid mb-3"
                      style="
                        max-height: 200px;
                        object-fit: cover;
                        border-radius: 8px;
                      "
                    />
                    <span v-else class="text-muted">Belum tersedia</span>
                  </div>

                  <!-- Foto Selfie Section -->
                  <div class="text-center flex-fill mx-2">
                    <h4 class="mb-2">Foto Selfie</h4>
                    <img
                      v-if="
                        safeGet(items, 'user_corporate_profile.foto_ktp_path')
                      "
                      :src="items.user_corporate_profile.foto_selfie_path"
                      alt="Foto Selfie"
                      class="img-fluid mb-3"
                      style="
                        max-height: 200px;
                        object-fit: cover;
                        border-radius: 8px;
                      "
                    />
                    <span v-else class="text-muted">Belum tersedia</span>
                  </div>
                </div>
                <hr />
                <h4>Data Rekening</h4>
                <div
                  v-if="items.user_bank"
                  class="d-flex flex-wrap"
                >
                  <div class="data-item">
                    <h5>Nama Bank</h5>
                    <span>{{ items.user_bank.bank.name || "-" }}</span>
                  </div>
                  <div class="data-item">
                    <h5>Nomor Rekening</h5>
                    <span>{{ items.user_bank.account_number || "-" }}</span>
                  </div>
                  <div class="data-item">
                    <h5>Nama Pemilik Rekening</h5>
                    <span>{{ items.user_bank.account_name || "-" }}</span>
                  </div>
                </div>
                <!-- If no bank data -->
                <div v-else class="text-center mt-3">
                  <h5 class="font-weight-bold text-danger mt-0">
                    Data rekening tidak tersedia
                  </h5>
                </div>
                <hr />
                <div class="text-center mb-3">
                  <b-button
                    @click="downloadPDF"
                    class="font-weight-bold btn-custom"
                    :disabled="isDownloading"
                  >
                    <b-spinner
                      v-if="isDownloading"
                      small
                      label="Downloading..."
                    ></b-spinner>
                    <span v-else>Download PDF</span>
                  </b-button>
                  <b-button
                    @click="downloadSK"
                    class="font-weight-bold btn-custom"
                    :disabled="isDownloadingSK"
                  >
                    <b-spinner
                      v-if="isDownloadingSK"
                      small
                      label="Downloading..."
                    ></b-spinner>
                    <span v-else>Download Surat Kuasa</span>
                  </b-button>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Modal Nasabah Dihapus -->
    <b-modal
      v-model="showDeletedModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center p-4">
        <div class="mb-3">
          <b-icon
            icon="exclamation-triangle-fill"
            variant="warning"
            style="width: 60px; height: 60px"
          ></b-icon>
        </div>
        <h4 class="font-weight-bold text-dark mb-3">Informasi Nasabah</h4>
        <p class="text-muted mb-4">
          Nasabah ini telah dihapus karena Kebijakan Privasi (Retensi Data)
        </p>
        <b-button
          variant="primary"
          class="btn-custom px-4 py-2"
          @click="showDeletedModal = false"
        >
          Tutup
        </b-button>
      </div>
    </b-modal>
    <js />
  </div>
</template>

<script>
import Funder from "../../api/funder.js";
import Pengajuan from "../../api/pengajuan.js";
import BFormInputWithMask from "../../components/masking-input.vue";
import MaskingViewData from "../../components/masking-view-data.vue"

export default {
  name: "ShowPengajuanCorporate",
  components: {
    BFormInputWithMask,
    MaskingViewData,
  },
  data() {
    return {
      isLoading: true,
      isDownloading: false,
      showDeletedModal: false,
      items: [],
      apiUrl: process.env.API_URL,

      wilayah_corporate: {
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
      },

      wilayah_profile: {
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
      },

      wilayah_domicily: {
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
      },

      itemPengajuans: {},
      isDownloadingSK: false,

      establishment_date_parsed: "",
      date_of_birth_parsed: "",

      mask: {
        taxpayer_number: true,
        deed_number: true,
        latest_deed_number: true,
        establishment_menkumham_number: true,
        latest_menkumham_number: true,
        business_identification_number: true,
        establishment_date: true,
        address: true,
        phone: true,
        email: true,
        no_telpon: true,
        alternate_phone: true,
        email_2: true,
        identity_number: true,
        taxpayer_number_2: true,
        identity_address: true,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    items: {
      handler(val) {
        const detail = (val && val.user_corporate_detail) || {};
        const profile = (val && val.user_corporate_profile) || {};
        this.fetchNamaWilayah(detail);
        this.fetchNamaWilayahProfile(profile);
        this.fetchNamaWilayahProfileDomicily(profile);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    safeGet(obj, path) {
      return path.split(".").reduce((acc, key) => acc && acc[key], obj);
    },
    viewNPWPPDF(filename) {
      const pdfUrl = `${this.apiUrl}/storage/user-profile/${filename}`;
      window.open(pdfUrl, "_blank");
    },

    convertCertificationStatus(status) {
      const certStatusMap = {
        0: "❌ Tidak Ada Sertifikat",
        1: "⏳ Dalam Proses Verifikasi",
        2: "📝 Sertifikat Terbit (Menunggu Konfirmasi User)",
        3: "✅ Sertifikat Aktif",
        4: "❌ Sertifikat Ditolak oleh Validator",
      };
      return certStatusMap[status] || "-";
    },

    // Konversi Status Registrasi
    convertStatus(status) {
      const statusMap = {
        S: "✅ Sukses",
        F: "❌ Gagal (Data tidak sesuai dengan Dukcapil)",
        E: "⚠️ Error (Gagal koneksi ke Dukcapil)",
        B: "⏳ Masih dalam tahap verifikasi",
        D: "📝 Masih dalam tahap pengisian form",
      };
      return statusMap[status] || "-";
    },

    // Konversi FR Score dan Percentage
    convertFRScore(score, percentage) {
      if (score === "A" || (score === "B" && percentage >= 75.0)) {
        return "✅ Lolos Dukcapil";
      } else if (score === "C" && percentage >= 50.0) {
        return "❌ Tidak Lolos Dukcapil";
      } else if (score === "D" || percentage < 50.0) {
        return "❌ Tidak Lolos Dukcapil";
      }
      return "-";
    },

    // Konversi Reason Code
    convertReasonCode(code) {
      const reasonMap = {
        0: "✅ Sukses e-KYC",
        1: "❌ Gagal Dukcapil (Data tidak sesuai)",
        2: "❌ Liveness Gagal",
        3: "⚠️ Register ID Expired",
      };
      return reasonMap[code] || "-";
    },

    // Konversi Manual Registration Status
    convertManualRegistration(status) {
      const manualMap = {
        P: "⏳ Belum Memulai Manual Registration",
        I: "📝 Sedang Mengisi Form Manual Registration",
        V: "🔍 Sedang Diverifikasi Tilaka",
        S: "✅ Manual Registration Sukses",
        F: "❌ Manual Registration Gagal",
        E: "⚠️ Register ID Expired",
      };
      return manualMap[status] || "-";
    },

    formatRupiah(value) {
      // Menghilangkan angka di belakang koma
      const cleanValue = Math.floor(parseFloat(value)); // Buang desimal

      if (!cleanValue) return "Rp. 0";
      const numberString = cleanValue
        .toString()
        .replace(/[^,\d]/g, "")
        .toString();
      let rest = numberString.length % 3;
      let rupiah = numberString.substr(0, rest);
      const thousand = numberString.substr(rest).match(/\d{3}/gi);

      if (thousand) {
        const separator = rest ? "." : "";
        rupiah += separator + thousand.join(".");
      }

      return "Rp. " + rupiah;
    },
    formatDateIndonesian(date) {
      if (!date) return "";

      const onlyDate = date.split(" ")[0]; // hasilnya: "1997-10-03"
      const [year, month, day] = onlyDate.split("-");

      const monthNames = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      return `${day} ${monthNames[parseInt(month, 10) - 1]} ${year}`;
    },
    formatCapitalized(status) {
      if (!status) return "-";
      return status
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    },
    formatUpperCase(status) {
      if (!status) return "-";
      return status
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
    loadData() {
      this.isLoading = true;
      const funderId = this.$route.params.funderId;
      const pengajuanId = this.$route.params.pengajuanId;

      Funder.showV3(funderId)
        .then((res) => {
          this.items = res.data.data.user || {};
          if (this.items && this.items.is_deleted === true) {
            this.showDeletedModal = true;
          }
          const detail = this.items.user_corporate_detail || {};
          const profile = this.items.user_corporate_profile || {};

          this.establishment_date_parsed = detail.establishment_date
            ? this.formatDateIndonesian(detail.establishment_date)
            : "";
          this.date_of_birth_parsed = profile.date_of_birth
            ? this.formatDateIndonesian(profile.date_of_birth)
            : "";
        })
        .catch((error) => {
          console.error("Error loading funder data:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });

      Pengajuan.showPengajuanMitraPendukungCorporate(pengajuanId)
        .then((res) => {
          this.itemPengajuans = res.data.data || {};
          if (this.itemPengajuans && this.itemPengajuans.is_deleted === true) {
            this.showDeletedModal = true;
          }
        })
        .catch((error) => {
          console.error("Error loading pengajuan data:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async fetchNamaWilayah(profile) {
      try {
        const [prov, kota, kec, kel] = await Promise.all([
          this.$getNamaWilayah("provinsi", profile.province_id),
          this.$getNamaWilayah("kota", profile.city_id),
          this.$getNamaWilayah("kecamatan", profile.district_id),
          this.$getNamaWilayah("kelurahan", profile.sub_district_id),
        ]);

        this.wilayah_corporate = {
          provinsi: (prov && prov.name) || "-",
          kota: (kota && kota.name) || "-",
          kecamatan: (kec && kec.name) || "-",
          kelurahan: (kel && kel.name) || "-",
        };
        this.isLoading = false;
      } catch (error) {
        this.isLoading = true;
        console.error("Gagal mengambil nama wilayah:", error);
      }
    },
    async fetchNamaWilayahProfile(profile) {
      try {
        const [prov, kota, kec, kel] = await Promise.all([
          this.$getNamaWilayah("provinsi", profile.identity_province_id),
          this.$getNamaWilayah("kota", profile.identity_city_id),
          this.$getNamaWilayah("kecamatan", profile.identity_district_id),
          this.$getNamaWilayah("kelurahan", profile.identity_sub_district_id),
        ]);

        this.wilayah_profile = {
          provinsi: (prov && prov.name) || "-",
          kota: (kota && kota.name) || "-",
          kecamatan: (kec && kec.name) || "-",
          kelurahan: (kel && kel.name) || "-",
        };
        // console.log("wilayah prof: ", this.wilayah_profile);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = true;
        console.error("Gagal mengambil nama wilayah:", error);
      }
    },
    async fetchNamaWilayahProfileDomicily(profile) {
      try {
        const [prov, kota, kec, kel] = await Promise.all([
          this.$getNamaWilayah("provinsi", profile.current_province_id),
          this.$getNamaWilayah("kota", profile.current_city_id),
          this.$getNamaWilayah("kecamatan", profile.current_district_id),
          this.$getNamaWilayah("kelurahan", profile.current_sub_district_id),
        ]);

        this.wilayah_domicily = {
          provinsi: (prov && prov.name) || "-",
          kota: (kota && kota.name) || "-",
          kecamatan: (kec && kec.name) || "-",
          kelurahan: (kel && kel.name) || "-",
        };
        // console.log("wilayah prof: ", this.wilayah_domicily);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = true;
        console.error("Gagal mengambil nama wilayah:", error);
      }
    },
    async downloadPDF() {
      this.isDownloading = true;
      try {
        const response = await Pengajuan.downloadPengajuan(
          this.$route.params.pengajuanId
        );

        if (response && response.status === 200) {
          const pengajuanId = this.$route.params.pengajuanId;
          const now = new Date();
          const timestamp =
            now.getHours().toString().padStart(2, "0") +
            now.getMinutes().toString().padStart(2, "0") +
            now.getSeconds().toString().padStart(2, "0");

          const filename = `pengajuan_${pengajuanId}_${timestamp}.pdf`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.showToast(
            "Dokumen berhasil diunduh otomatis",
            "Sukses",
            "success"
          );
        } else {
          this.showToast(
            "Gagal mengunduh dokumen. Status tidak terduga.",
            "Kesalahan",
            "danger"
          );
        }
      } catch (error) {
        console.error("Terjadi kesalahan saat mendownload dokumen.", error);
        this.showToast(
          "Terjadi kesalahan saat mendownload dokumen.",
          "Kesalahan",
          "danger"
        );
      } finally {
        this.isDownloading = false;
      }
    },
    async downloadSK() {
      this.isDownloadingSK = true;
      try {
        const getDocumentResponse = await Pengajuan.getDocumentUrl({
          pengajuan_id: this.$route.params.pengajuanId,
          to_cdn: true,
        });

        if (getDocumentResponse.data.meta.code === 200) {
          const { url: documentUrl, filename } = getDocumentResponse.data.data;

          const link = document.createElement("a");
          link.href = documentUrl;
          link.setAttribute("download", filename || "document.pdf");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$toast.success("Dokumen berhasil diunduh otomatis");
        } else {
          this.$toast.error(
            getDocumentResponse.data.meta.message ||
              "Gagal mengunduh dokumen. Status tidak terduga."
          );
        }
      } catch (error) {
        console.error("Terjadi kesalahan saat mendownload dokumen.", error);
        this.$toast.error("Terjadi kesalahan saat mendownload dokumen.");
      } finally {
        this.isDownloadingSK = false;
      }
    },
  },
};
</script>

<style>
.d-flex {
  display: flex;
  flex-wrap: wrap;
}

.data-item {
  flex: 1 0 30%;
  /* Flex-grow, flex-shrink, flex-basis */
  margin-right: 1.5rem;
  /* Space between items */
  margin-bottom: 1rem;
  /* Space below items */
}

.data-item:nth-child(3n) {
  margin-right: 0;
  /* Remove margin for every third item */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.bold {
  font-weight: 600;
}

/* Skeleton Loading Animation Styles */
.skeleton-pulse {
  background: linear-gradient(-90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%);
  background-size: 400% 400%;
  animation: pulse 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.skeleton-btn {
  width: 100px;
  height: 35px;
}

.skeleton-title {
  width: 280px;
  height: 40px;
}

.skeleton-section-title {
  width: 160px;
  height: 28px;
}

.skeleton-label {
  width: 120px;
  height: 18px;
}

.skeleton-value {
  width: 80%;
  height: 24px;
}

.skeleton-img {
  width: 200px;
  height: 200px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/public/dashboard/show-pengajuan-corporate.vue